import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { Panel, Message } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { saveProjectApprovalSummaryForStaffSubProject } from '../../redux/actions/projectApprovalSummaryForStaff'
import { startLoading, doneLoading } from '../../utils/loading'
import ButtonPanelWidget from '../ButtonPanelWidget'
import ProjectApprovalSummaryForStaffForm from './ProjectApprovalSummaryForStaffForm'
import moment from 'moment'
import pathname from '../../constants/pathname'
import ConfirmWidget from '../confirm/ConfirmWidget'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'

export default function ProjectApprovalSummaryForStaffWidget(props) {
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [formSchema, setFormSchema] = useState(props.schema)
  const [errorMsg, setErrorMsg] = useState()
  const [isShowConfimModal, setIsShowConfimModal] = useState(false)
  const [saveRequest, setSaveRequest] = useState({})
  const history = useHistory()

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const onSubmit = (data) => {
    // console.log('data', data)

    let request = {
      projectVersionId: projectId,
      typeOfApprover: data.typeOfApprover,
      approveDate: moment(data.approveTime).format('DD/MM/YYYY'),
      prefixName: formSchema.approver.approverName.prefixName || null,
      approver: formSchema.approver.approverName.value || null,
      // supportiveness: data.supportivenessOption || null,  //ไม่ใช้แล้ว
      // attractiveness: data.attractivenessOption || null, //ไม่ใช้แล้ว
      // risk: data.riskOption || null, //ไม่ใช้แล้ว
      // discription: '',
    }
    setIsShowConfimModal(true)
    setSaveRequest(request)
    // handleCallServiceSubProject(projectId, request)
  }

  const onConfirm = () => {
    setIsShowConfimModal(false)
    handleCallServiceSubProject(projectId, saveRequest)
    setSaveRequest({})
  }

  const handleCallServiceSubProject = async (id, request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      let response
      response = await saveProjectApprovalSummaryForStaffSubProject(id, request)
      // console.log('res ', response)
      if (response) {
        setFormSchema(response)
        setErrorMsg({ type: 'success', description: 'บันทึกสำเร็จ' })
        setTimeout(() => {
          setErrorMsg(null)
          if (response.newProjectVersionId) {
            sessionStorage.setItem('projectId', response.newProjectVersionId)
            sessionStorage.setItem('param', '')

            return history.push(`${pathname.subProject.overviewSubProject}`)
          } else {
            return history.push(`${pathname.subProject.overviewSubProject}`)
          }
        }, 3000)
      } else {
        setIsError(true)
      }
    } catch (e) {
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  return (
    <>
      {isLoading && <OverlayLoader />}

      <Panel shaded header={formSchema.header} bordered collapsible defaultExpanded>
        <ProjectApprovalSummaryForStaffForm
          schema={formSchema}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          getValues={getValues}
          setValue={setValue}
          clearErrors={clearErrors}
          isDisabled={formSchema.disabled || false}
        />
        <hr />

        {errorMsg && (
          <Message
            showIcon
            type={errorMsg.type}
            description={errorMsg.description}
            style={{ marginBottom: 20 }}
          />
        )}

        <ButtonPanelWidget
          isEdit={true}
          isError={isError}
          isDisabled={formSchema.disabled || false}
          buttonText={{
            disabled: false,
            errorMessage: 'บันทึกไม่สำเร็จ',
            saveButtonName: 'บันทึกสรุปผลการพิจารณาอนุมัติโครงการ',
          }}
          onSave={handleSubmit(onSubmit)}
        />

        <ConfirmWidget
          title={`ยืนยันการบันทึก`}
          show={isShowConfimModal}
          detail={`ยืนยันการสรุปผลการพิจารณาอนุมัติโครงการ`}
          onCancle={() => setIsShowConfimModal(false)}
          onConfirm={onConfirm}
        />
      </Panel>
    </>
  )
}
